import { Button } from "primereact/button";

import { ErrorState, ExportTableDialog, ForbiddenState, StateMessage } from "@/ds";
import { SecoesMenu } from "@/shared/components";
import { FichaSecao } from "../ficha-secao";
import {
  FICHA_EXPORT_ESCOPO,
  FICHA_LOADING_LABEL,
  FICHA_MENU_LABEL,
  PREVIA_CANCELAR_LABEL,
  PREVIA_FECHAR_LABEL,
  PREVIA_SALVAR_LABEL,
} from "./financeiro-ficha-viewer.constants";
import styles from "./financeiro-ficha-viewer.module.scss";
import type { FinanceiroFichaViewerViewModel } from "./types-financeiro-ficha-viewer";

/** Menu lateral das 8 seções e o corpo rolável com todas elas em sequência. */
export function FinanceiroFichaViewerView({
  status,
  errorMessage,
  recarregar,
  temDados,
  isMobile,
  sections,
  menu,
  activeId,
  mobileAttr,
  bodyRef,
  selecionarSecao,
  propsCorpo,
  acoes,
  exportDialog,
  emGeracao,
  emPrevia,
  anexosDe,
  anexosPrevia,
  salvando,
  salvar,
  cancelar,
  fechar,
}: FinanceiroFichaViewerViewModel) {
  if (status === "loading") {
    return (
      <div className={styles.estado}>
        <StateMessage variant="loading" title={FICHA_LOADING_LABEL} testId="ficha-loading" />
      </div>
    );
  }

  if (status === "forbidden") {
    return (
      <div className={styles.estado}>
        <ForbiddenState description={errorMessage ?? undefined} testId="ficha-error" />
      </div>
    );
  }

  if (status === "error" || !temDados) {
    return (
      <div className={styles.estado}>
        <ErrorState message={errorMessage ?? undefined} onRetry={recarregar} testId="ficha-error" />
      </div>
    );
  }

  const secoesMenu = (
    <SecoesMenu
      items={menu}
      activeId={activeId}
      onSelect={selecionarSecao}
      isMobile={isMobile}
      className={isMobile ? undefined : styles.menu}
      acompanharAtivo
      label={FICHA_MENU_LABEL}
      testId="ficha-menu"
      selectTestId="ficha-section-select"
    />
  );

  return (
    <div className={styles.raiz}>
      <div className={styles.layout} data-mobile={mobileAttr} data-testid="ficha-viewer">
        {isMobile ? <div className={styles.seletor}>{secoesMenu}</div> : secoesMenu}

        <div className={styles.corpo} ref={bodyRef} {...propsCorpo} data-testid="ficha-body">
          {sections.map((section) => (
            <FichaSecao
              key={section.id}
              section={section}
              acoes={acoes}
              semAcoesTopo={emPrevia}
              anexosDe={anexosDe}
              anexosPrevia={anexosPrevia}
            />
          ))}
        </div>
      </div>

      {exportDialog.isOpen ? (
        <ExportTableDialog
          listName="ficha financeira"
          scopeDescription={FICHA_EXPORT_ESCOPO}
          isExporting={exportDialog.isExporting}
          xlsxLayouts={exportDialog.xlsxLayouts}
          onExport={exportDialog.exportar}
          onCancel={exportDialog.fechar}
        />
      ) : null}

      {emGeracao ? (
        <div className={styles.rodape} data-testid="ficha-rodape">
          {emPrevia ? (
            <div className={styles.rodapeAcoes}>
              <Button
                type="button"
                label={PREVIA_CANCELAR_LABEL}
                text
                severity="secondary"
                disabled={salvando}
                onClick={cancelar}
                data-testid="ficha-cancelar"
              />
              <Button
                type="button"
                label={PREVIA_SALVAR_LABEL}
                loading={salvando}
                onClick={salvar}
                data-testid="ficha-salvar"
              />
            </div>
          ) : (
            <Button
              type="button"
              label={PREVIA_FECHAR_LABEL}
              severity="secondary"
              onClick={fechar}
              data-testid="ficha-fechar"
            />
          )}
        </div>
      ) : null}
    </div>
  );
}
